import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import JustAttendAd from '../../components/JustAttendAd.jsx';
import { ARTICLES, GROUPS } from './articles/index.js';

export default function HelpIndex() {
  const [q, setQ] = useState('');
  const shown = useMemo(() => {
    const words = q.toLowerCase().split(/\s+/).filter(Boolean);
    return words.length ? ARTICLES.filter((a) => words.every((w) => `${a.title} ${a.summary}`.toLowerCase().includes(w))) : ARTICLES;
  }, [q]);

  return (
    <div className="page">
      <div className="help-hero">
        <h1>How can we help?</h1>
        <p className="plan-lead">Every page in the portal has a guide here, written in plain English with examples. You’ll also find a “How this page works” link at the top of each page.</p>
        <div className="field help-search">
          <label htmlFor="help-q">Search the guides</label>
          <input id="help-q" type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="For example: fake invoice, domain, check page" />
        </div>
      </div>

      <div className="help-index-layout">
        <div className="help-index-main">
          {GROUPS.map(([key, label]) => {
            const items = shown.filter((a) => a.group === key);
            if (!items.length) return null;
            return (
              <section key={key} aria-labelledby={`g-${key}`}>
                <h2 id={`g-${key}`}>{label}</h2>
                <div className="help-cards">
                  {items.map((a) => (
                    <Link key={a.slug} to={`/help/${a.slug}`} className="help-card">
                      <strong>{a.title}</strong>
                      <span>{a.summary}</span>
                    </Link>
                  ))}
                </div>
              </section>
            );
          })}
          {!shown.length && <p className="muted">Nothing matches “{q}”. Try other words, or <Link to="/contact">ask us</Link>.</p>}
        </div>
        <aside className="help-index-side">
          <section className="card">
            <h2>Still stuck?</h2>
            <p>Send us a message and a real person will get back to you, usually the same working day.</p>
            <Link to="/contact" className="btn btn-primary">Contact us</Link>
          </section>
          <JustAttendAd />
        </aside>
      </div>
    </div>
  );
}
